import { getProducts, GetPurchaseHistoryApiParameter } from "@GeriMed/Services/PurchaseHistoryService";
import { CustomerDisplayProductCollection } from "@GeriMed/Type/ApiModelsExt";
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";


type HandlerType = ApiHandler<GetPurchaseHistoryApiParameter, CustomerDisplayProductCollection>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const DispatchBeginLoadPurchaseHistoryList: HandlerType = props => {
    props.dispatch({
        type: "Data/PurchaseHistory/BeginLoadPurchaseHistory" as any,
        parameter: props.parameter,
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getProducts(props.apiParameter);
};
export const DispatchCompleteLoadPurchaseHistoryList: HandlerType = props => {
    props.dispatch({
        type: "Data/PurchaseHistory/CompleteLoadPurchaseHistory" as any,
        collection: props.apiResult,
        parameter: props.parameter,
    });
};

export const chain = [
    PopulateApiParameter,
    DispatchBeginLoadPurchaseHistoryList,
    RequestDataFromApi,
    DispatchCompleteLoadPurchaseHistoryList,
];

const loadPurchaseHistoryList = createHandlerChainRunner(chain, "loadPurchaseHistoryList");
export default loadPurchaseHistoryList;
